import { createSlice } from "@reduxjs/toolkit";
import { subDays } from "date-fns";

const startDate = new Date(subDays(new Date(), 30)).toISOString().split("T")[0];
const endDate = new Date(new Date()).toISOString().split("T")[0];

const initialState = {
  currentPage: 1,
  sortBy: "",
  sortOrder: "",
  search: "",
  date: [startDate,endDate],
  editModal: false,
  currentPage: 1,
  currentFilter: "all",
  currentPageSize: 10,
  sortBy: "",
  sortOrder: "dec",
  search: "",
  clear: false,
  showAddModal: false,
  showDeleteModal: false,
};
const activitylogSlice = createSlice({
  name: "activitylog",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
    resetConfig: () => initialState,
  },
});

export const { updateConfig, resetConfig } = activitylogSlice.actions;

export default activitylogSlice.reducer;
